import { render } from "./SalaryExportsHistoryModal.vue?vue&type=template&id=78071e4a&ts=true"
import script from "./SalaryExportsHistoryModal.vue?vue&type=script&lang=ts"
export * from "./SalaryExportsHistoryModal.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__